import React from "react";
import AsyncSelect from "react-select/async";

export const AsyncLabSelect = (props) => {
  const newProps = { ...props };
  const { onChange, onBlur, name, formik, defiaultValue } = newProps;

  const onChangeOverride = (selected, options) => {
    if (onChange) {
      onChange(selected, options);
    }
    if (name && formik) {
      formik.setFieldValue(name, selected && selected.value);
    }
  };

  const onBlurOverride = (event) => {
    if (onBlur) {
      onBlur(event);
    }
    if (name && formik) {
      formik.setFieldTouched(name);
    }
  };

  newProps.onChange = onChangeOverride;
  newProps.onBlur = onBlurOverride;

  return (
    <AsyncSelect
      {...newProps}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary50: "#E9EDF2",
        },
      })}
      defaultValue={defiaultValue}
      styles={{
        // menu: (provided, state) => ({ ...provided, zIndex: 9999 }),
        // menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        // menuList: (provided, state) => ({ ...provided, padding: "0" }),
        // container: (provided, state) => ({ ...provided, width: "100%" }),

        option: (provided, state) => {
          if (state.isSelected || state.isFocused) {
            return {
              ...provided,
              fontFamily: "Nunito",
              fontSize: " 18px",
              fontWeight: " 300",
              textAlign: "left",
              backgroundColor: "#E9EDF2",
              color: "black",
              ":focus": {
                fontFamily: "Nunito",
                fontSize: " 18px",
                fontWeight: " 300",
                textAlign: "left",
                backgroundColor: "#f8f8f8",
                color: "black",
              },
              ":hover": {
                fontFamily: "Nunito",
                fontSize: " 18px",
                fontWeight: " 300",
                textAlign: "left",
                backgroundColor: "#f8f8f8",
                color: "black",
              },
            };
          }
          return {
            ...provided,
            fontFamily: "Nunito",
            fontSize: " 18px",
            fontWeight: " 300",
            textAlign: "left",
          };
        },
        control: (provided, state) => {
          const result = {
            ...provided,
            fontFamily: "Nunito",
            fontSize: " 18px",
            fontWeight: " 300",
            textAlign: "left",
            border: newProps.border || "none",
            borderBottom: newProps.border || "1px solid gray",
            borderRadius: newProps.borderRadius || "0px",
            // backgroundColor: "#E9EDF2",
          };
          if (state.isSelected || state.isFocused) {
            return {
              ...result,
              border: "none",
              outline: "none",
              boxShadow: "0px 2px 0px 0px rgba(0,0,0,0)",
              ":hover": {
                border: "none",
              },
              ":focus": {
                border: "none !important",
                outline: "none !important",
              },
            };
          }
          return result;
        },
      }}
    />
  );
};

AsyncLabSelect.propTypes = AsyncSelect.propTypes;
